import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class Miscellaneous{
    static attributePrefix = "Miscellaneous";
    static attributePrefixDe = "Sonstiges";}